import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _441d4db3 = () => interopDefault(import('../pages/achievement/index.vue' /* webpackChunkName: "pages/achievement/index" */))
const _205886eb = () => interopDefault(import('../pages/advertise/index.vue' /* webpackChunkName: "pages/advertise/index" */))
const _4713f10e = () => interopDefault(import('../pages/agreement/index.vue' /* webpackChunkName: "pages/agreement/index" */))
const _6d830160 = () => interopDefault(import('../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _2ec88820 = () => interopDefault(import('../pages/customer/index.vue' /* webpackChunkName: "pages/customer/index" */))
const _1d88b186 = () => interopDefault(import('../pages/details/index.vue' /* webpackChunkName: "pages/details/index" */))
const _24cf1878 = () => interopDefault(import('../pages/goals/index.vue' /* webpackChunkName: "pages/goals/index" */))
const _2b8e8b9f = () => interopDefault(import('../pages/maisoku/index.vue' /* webpackChunkName: "pages/maisoku/index" */))
const _7272a2e8 = () => interopDefault(import('../pages/media/index.vue' /* webpackChunkName: "pages/media/index" */))
const _88a0f0ee = () => interopDefault(import('../pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _1f04299d = () => interopDefault(import('../pages/project/index.vue' /* webpackChunkName: "pages/project/index" */))
const _748d1eda = () => interopDefault(import('../pages/response/index.vue' /* webpackChunkName: "pages/response/index" */))
const _eae1bece = () => interopDefault(import('../pages/sale/index.vue' /* webpackChunkName: "pages/sale/index" */))
const _6c92be20 = () => interopDefault(import('../pages/achievement/output.vue' /* webpackChunkName: "pages/achievement/output" */))
const _edf65130 = () => interopDefault(import('../pages/achievement/registration.vue' /* webpackChunkName: "pages/achievement/registration" */))
const _b602515a = () => interopDefault(import('../pages/advertise/analysis.vue' /* webpackChunkName: "pages/advertise/analysis" */))
const _90d4d50c = () => interopDefault(import('../pages/advertise/management.vue' /* webpackChunkName: "pages/advertise/management" */))
const _60a94f30 = () => interopDefault(import('../pages/advertise/registration.vue' /* webpackChunkName: "pages/advertise/registration" */))
const _0919e9aa = () => interopDefault(import('../pages/calendar/registration.vue' /* webpackChunkName: "pages/calendar/registration" */))
const _06934aea = () => interopDefault(import('../pages/customer/registration.vue' /* webpackChunkName: "pages/customer/registration" */))
const _71ebe04c = () => interopDefault(import('../pages/goals/analysis.vue' /* webpackChunkName: "pages/goals/analysis" */))
const _5e3b087c = () => interopDefault(import('../pages/goals/setting.vue' /* webpackChunkName: "pages/goals/setting" */))
const _1d0d62f6 = () => interopDefault(import('../pages/line/tracking/index.vue' /* webpackChunkName: "pages/line/tracking/index" */))
const _28d289b7 = () => interopDefault(import('../pages/maisoku/export.vue' /* webpackChunkName: "pages/maisoku/export" */))
const _7634c0bd = () => interopDefault(import('../pages/maisoku/template.vue' /* webpackChunkName: "pages/maisoku/template" */))
const _0ce5b888 = () => interopDefault(import('../pages/response/registration.vue' /* webpackChunkName: "pages/response/registration" */))
const _517f2aca = () => interopDefault(import('../pages/sale/output.vue' /* webpackChunkName: "pages/sale/output" */))
const _2f499a38 = () => interopDefault(import('../pages/setting/announcement/index.vue' /* webpackChunkName: "pages/setting/announcement/index" */))
const _b0b7e8d4 = () => interopDefault(import('../pages/setting/import/index.vue' /* webpackChunkName: "pages/setting/import/index" */))
const _62343a12 = () => interopDefault(import('../pages/setting/mail-template.vue' /* webpackChunkName: "pages/setting/mail-template" */))
const _09659f6e = () => interopDefault(import('../pages/setting/matching-mail.vue' /* webpackChunkName: "pages/setting/matching-mail" */))
const _af8058b8 = () => interopDefault(import('../pages/setting/shop.vue' /* webpackChunkName: "pages/setting/shop" */))
const _b07ec7b6 = () => interopDefault(import('../pages/setting/staff/index.vue' /* webpackChunkName: "pages/setting/staff/index" */))
const _1f570e5d = () => interopDefault(import('../pages/setting/step-mail/index.vue' /* webpackChunkName: "pages/setting/step-mail/index" */))
const _4886fadf = () => interopDefault(import('../pages/setting/tag/index.vue' /* webpackChunkName: "pages/setting/tag/index" */))
const _df9208b6 = () => interopDefault(import('../pages/shop/document-template/index.vue' /* webpackChunkName: "pages/shop/document-template/index" */))
const _788f9680 = () => interopDefault(import('../pages/shop/message/index.vue' /* webpackChunkName: "pages/shop/message/index" */))
const _3215217e = () => interopDefault(import('../pages/message/line/edit.vue' /* webpackChunkName: "pages/message/line/edit" */))
const _b1085b00 = () => interopDefault(import('../pages/message/line/log.vue' /* webpackChunkName: "pages/message/line/log" */))
const _c900bd20 = () => interopDefault(import('../pages/message/line/registration/index.vue' /* webpackChunkName: "pages/message/line/registration/index" */))
const _69f61870 = () => interopDefault(import('../pages/message/line/select.vue' /* webpackChunkName: "pages/message/line/select" */))
const _1cf293fc = () => interopDefault(import('../pages/message/line/send.vue' /* webpackChunkName: "pages/message/line/send" */))
const _5077b543 = () => interopDefault(import('../pages/message/mail/log.vue' /* webpackChunkName: "pages/message/mail/log" */))
const _525c994a = () => interopDefault(import('../pages/message/mail/registration.vue' /* webpackChunkName: "pages/message/mail/registration" */))
const _422f9acd = () => interopDefault(import('../pages/message/mail/select.vue' /* webpackChunkName: "pages/message/mail/select" */))
const _d919ecce = () => interopDefault(import('../pages/message/mail/send.vue' /* webpackChunkName: "pages/message/mail/send" */))
const _74b1497a = () => interopDefault(import('../pages/setting/announcement/registration.vue' /* webpackChunkName: "pages/setting/announcement/registration" */))
const _5c0252dd = () => interopDefault(import('../pages/setting/import/Detail.vue' /* webpackChunkName: "pages/setting/import/Detail" */))
const _c4eb77b6 = () => interopDefault(import('../pages/setting/import/registration.vue' /* webpackChunkName: "pages/setting/import/registration" */))
const _720f09ef = () => interopDefault(import('../pages/setting/real-estate-agent/property-range.vue' /* webpackChunkName: "pages/setting/real-estate-agent/property-range" */))
const _35f3c4b6 = () => interopDefault(import('../pages/setting/staff/registration.vue' /* webpackChunkName: "pages/setting/staff/registration" */))
const _28dae37e = () => interopDefault(import('../pages/setting/step-mail/registration.vue' /* webpackChunkName: "pages/setting/step-mail/registration" */))
const _5d650ea1 = () => interopDefault(import('../pages/message/line/registration/success.vue' /* webpackChunkName: "pages/message/line/registration/success" */))
const _3b421e13 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _3a2edf46 = () => interopDefault(import('../pages/message/mail/edit/_id.vue' /* webpackChunkName: "pages/message/mail/edit/_id" */))
const _dd946daa = () => interopDefault(import('../pages/agreement/log/_id.vue' /* webpackChunkName: "pages/agreement/log/_id" */))
const _54f676d8 = () => interopDefault(import('../pages/agreement/registration/_id.vue' /* webpackChunkName: "pages/agreement/registration/_id" */))
const _5b552df2 = () => interopDefault(import('../pages/customer/edit/_id.vue' /* webpackChunkName: "pages/customer/edit/_id" */))
const _6375f8be = () => interopDefault(import('../pages/media/registration/_id.vue' /* webpackChunkName: "pages/media/registration/_id" */))
const _4f6e9ee9 = () => interopDefault(import('../pages/project/registration/_id.vue' /* webpackChunkName: "pages/project/registration/_id" */))
const _5ab0a3cd = () => interopDefault(import('../pages/response/add/_id.vue' /* webpackChunkName: "pages/response/add/_id" */))
const _132e6ac0 = () => interopDefault(import('../pages/setting/announcement/_id.vue' /* webpackChunkName: "pages/setting/announcement/_id" */))
const _cabd3866 = () => interopDefault(import('../pages/setting/staff/_id.vue' /* webpackChunkName: "pages/setting/staff/_id" */))
const _3b1f0405 = () => interopDefault(import('../pages/setting/step-mail/_id.vue' /* webpackChunkName: "pages/setting/step-mail/_id" */))
const _081138e8 = () => interopDefault(import('../pages/shop/message/_id.vue' /* webpackChunkName: "pages/shop/message/_id" */))
const _a40dbe4a = () => interopDefault(import('../pages/achievement/_id.vue' /* webpackChunkName: "pages/achievement/_id" */))
const _55324214 = () => interopDefault(import('../pages/agreement/_id.vue' /* webpackChunkName: "pages/agreement/_id" */))
const _268101cc = () => interopDefault(import('../pages/client-history/_id.vue' /* webpackChunkName: "pages/client-history/_id" */))
const _4ac7fa58 = () => interopDefault(import('../pages/customer/_id.vue' /* webpackChunkName: "pages/customer/_id" */))
const _0ec78160 = () => interopDefault(import('../pages/media/_id.vue' /* webpackChunkName: "pages/media/_id" */))
const _044c2176 = () => interopDefault(import('../pages/project/_id.vue' /* webpackChunkName: "pages/project/_id" */))
const _303a9009 = () => interopDefault(import('../pages/property/_property.vue' /* webpackChunkName: "pages/property/_property" */))
const _5138ea9d = () => interopDefault(import('../pages/property/_property/contact/index.vue' /* webpackChunkName: "pages/property/_property/contact/index" */))
const _2bde7e6a = () => interopDefault(import('../pages/property/_property/contact/confirm.vue' /* webpackChunkName: "pages/property/_property/contact/confirm" */))
const _5efa638d = () => interopDefault(import('../pages/property/_property/contact/send.vue' /* webpackChunkName: "pages/property/_property/contact/send" */))
const _d7ff088a = () => interopDefault(import('../pages/response/_id.vue' /* webpackChunkName: "pages/response/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/achievement",
    component: _441d4db3,
    name: "achievement"
  }, {
    path: "/advertise",
    component: _205886eb,
    name: "advertise"
  }, {
    path: "/agreement",
    component: _4713f10e,
    name: "agreement"
  }, {
    path: "/calendar",
    component: _6d830160,
    name: "calendar"
  }, {
    path: "/customer",
    component: _2ec88820,
    name: "customer"
  }, {
    path: "/details",
    component: _1d88b186,
    name: "details"
  }, {
    path: "/goals",
    component: _24cf1878,
    name: "goals"
  }, {
    path: "/maisoku",
    component: _2b8e8b9f,
    name: "maisoku"
  }, {
    path: "/media",
    component: _7272a2e8,
    name: "media"
  }, {
    path: "/privacy",
    component: _88a0f0ee,
    name: "privacy"
  }, {
    path: "/project",
    component: _1f04299d,
    name: "project"
  }, {
    path: "/response",
    component: _748d1eda,
    name: "response"
  }, {
    path: "/sale",
    component: _eae1bece,
    name: "sale"
  }, {
    path: "/achievement/output",
    component: _6c92be20,
    name: "achievement-output"
  }, {
    path: "/achievement/registration",
    component: _edf65130,
    name: "achievement-registration"
  }, {
    path: "/advertise/analysis",
    component: _b602515a,
    name: "advertise-analysis"
  }, {
    path: "/advertise/management",
    component: _90d4d50c,
    name: "advertise-management"
  }, {
    path: "/advertise/registration",
    component: _60a94f30,
    name: "advertise-registration"
  }, {
    path: "/calendar/registration",
    component: _0919e9aa,
    name: "calendar-registration"
  }, {
    path: "/customer/registration",
    component: _06934aea,
    name: "customer-registration"
  }, {
    path: "/goals/analysis",
    component: _71ebe04c,
    name: "goals-analysis"
  }, {
    path: "/goals/setting",
    component: _5e3b087c,
    name: "goals-setting"
  }, {
    path: "/line/tracking",
    component: _1d0d62f6,
    name: "line-tracking"
  }, {
    path: "/maisoku/export",
    component: _28d289b7,
    name: "maisoku-export"
  }, {
    path: "/maisoku/template",
    component: _7634c0bd,
    name: "maisoku-template"
  }, {
    path: "/response/registration",
    component: _0ce5b888,
    name: "response-registration"
  }, {
    path: "/sale/output",
    component: _517f2aca,
    name: "sale-output"
  }, {
    path: "/setting/announcement",
    component: _2f499a38,
    name: "setting-announcement"
  }, {
    path: "/setting/import",
    component: _b0b7e8d4,
    name: "setting-import"
  }, {
    path: "/setting/mail-template",
    component: _62343a12,
    name: "setting-mail-template"
  }, {
    path: "/setting/matching-mail",
    component: _09659f6e,
    name: "setting-matching-mail"
  }, {
    path: "/setting/shop",
    component: _af8058b8,
    name: "setting-shop"
  }, {
    path: "/setting/staff",
    component: _b07ec7b6,
    name: "setting-staff"
  }, {
    path: "/setting/step-mail",
    component: _1f570e5d,
    name: "setting-step-mail"
  }, {
    path: "/setting/tag",
    component: _4886fadf,
    name: "setting-tag"
  }, {
    path: "/shop/document-template",
    component: _df9208b6,
    name: "shop-document-template"
  }, {
    path: "/shop/message",
    component: _788f9680,
    name: "shop-message"
  }, {
    path: "/message/line/edit",
    component: _3215217e,
    name: "message-line-edit"
  }, {
    path: "/message/line/log",
    component: _b1085b00,
    name: "message-line-log"
  }, {
    path: "/message/line/registration",
    component: _c900bd20,
    name: "message-line-registration"
  }, {
    path: "/message/line/select",
    component: _69f61870,
    name: "message-line-select"
  }, {
    path: "/message/line/send",
    component: _1cf293fc,
    name: "message-line-send"
  }, {
    path: "/message/mail/log",
    component: _5077b543,
    name: "message-mail-log"
  }, {
    path: "/message/mail/registration",
    component: _525c994a,
    name: "message-mail-registration"
  }, {
    path: "/message/mail/select",
    component: _422f9acd,
    name: "message-mail-select"
  }, {
    path: "/message/mail/send",
    component: _d919ecce,
    name: "message-mail-send"
  }, {
    path: "/setting/announcement/registration",
    component: _74b1497a,
    name: "setting-announcement-registration"
  }, {
    path: "/setting/import/Detail",
    component: _5c0252dd,
    name: "setting-import-Detail"
  }, {
    path: "/setting/import/registration",
    component: _c4eb77b6,
    name: "setting-import-registration"
  }, {
    path: "/setting/real-estate-agent/property-range",
    component: _720f09ef,
    name: "setting-real-estate-agent-property-range"
  }, {
    path: "/setting/staff/registration",
    component: _35f3c4b6,
    name: "setting-staff-registration"
  }, {
    path: "/setting/step-mail/registration",
    component: _28dae37e,
    name: "setting-step-mail-registration"
  }, {
    path: "/message/line/registration/success",
    component: _5d650ea1,
    name: "message-line-registration-success"
  }, {
    path: "/",
    component: _3b421e13,
    name: "index"
  }, {
    path: "/message/mail/edit/:id?",
    component: _3a2edf46,
    name: "message-mail-edit-id"
  }, {
    path: "/agreement/log/:id?",
    component: _dd946daa,
    name: "agreement-log-id"
  }, {
    path: "/agreement/registration/:id?",
    component: _54f676d8,
    name: "agreement-registration-id"
  }, {
    path: "/customer/edit/:id?",
    component: _5b552df2,
    name: "customer-edit-id"
  }, {
    path: "/media/registration/:id?",
    component: _6375f8be,
    name: "media-registration-id"
  }, {
    path: "/project/registration/:id?",
    component: _4f6e9ee9,
    name: "project-registration-id"
  }, {
    path: "/response/add/:id?",
    component: _5ab0a3cd,
    name: "response-add-id"
  }, {
    path: "/setting/announcement/:id",
    component: _132e6ac0,
    name: "setting-announcement-id"
  }, {
    path: "/setting/staff/:id",
    component: _cabd3866,
    name: "setting-staff-id"
  }, {
    path: "/setting/step-mail/:id?",
    component: _3b1f0405,
    name: "setting-step-mail-id"
  }, {
    path: "/shop/message/:id",
    component: _081138e8,
    name: "shop-message-id"
  }, {
    path: "/achievement/:id",
    component: _a40dbe4a,
    name: "achievement-id"
  }, {
    path: "/agreement/:id",
    component: _55324214,
    name: "agreement-id"
  }, {
    path: "/client-history/:id?",
    component: _268101cc,
    name: "client-history-id"
  }, {
    path: "/customer/:id",
    component: _4ac7fa58,
    name: "customer-id"
  }, {
    path: "/media/:id",
    component: _0ec78160,
    name: "media-id"
  }, {
    path: "/project/:id",
    component: _044c2176,
    name: "project-id"
  }, {
    path: "/property/:property?",
    component: _303a9009,
    name: "property-property",
    children: [{
      path: "contact",
      component: _5138ea9d,
      name: "property-property-contact"
    }, {
      path: "contact/confirm",
      component: _2bde7e6a,
      name: "property-property-contact-confirm"
    }, {
      path: "contact/send",
      component: _5efa638d,
      name: "property-property-contact-send"
    }]
  }, {
    path: "/response/:id",
    component: _d7ff088a,
    name: "response-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
